import { AxiosInstance } from 'axios';

import {
  ApolloClient,
  ApolloError,
  ApolloQueryResult,
  NormalizedCacheObject,
} from '@apollo/client';

import { GetCardContainerQuery, GetCardContainerQueryVariables } from '@/types';

import { GET_CARD_CONTAINER_QUERY } from '../../graphql/queries/getCardContainer';

export class MyAccountV2Service {
  constructor(
    private agent: AxiosInstance,
    private gqlAgent: ApolloClient<NormalizedCacheObject>
  ) {
    this.agent = agent;
    this.gqlAgent = gqlAgent;
  }

  public getCardContainer = async (
    variables: GetCardContainerQueryVariables
  ): Promise<{
    data: GetCardContainerQuery;
    error?: ApolloError;
    loading: boolean;
  }> => {
    const res: ApolloQueryResult<GetCardContainerQuery> = await this.gqlAgent.query({
      query: GET_CARD_CONTAINER_QUERY,
      variables: variables,
    });

    return {
      data: res.data,
      error: res.error,
      loading: res.loading,
    };
  };
}
